<template>
	<div class="offers">
		<go-back :routeName="'betslip'" :routeTitle="''" />
		<promo-list />
	</div>
</template>

<script>
import PromoList from "./List.vue";
export default {
	name: "promos",
	components: { PromoList },
};
</script>
